import { format, parseISO } from 'date-fns';
import { GridValueFormatterParams } from '@mui/x-data-grid-pro';
import { getDataSize, formatLongDateTimeString } from '@bymason/utils';

export const dataGridCapitalizationFormatter = (params: GridValueFormatterParams) => {
  const val = params.value as string;
  return val[0].toUpperCase() + val.slice(1);
};

export const dataGridDataSizeFormatter = (params: GridValueFormatterParams) => {
  const [size, unit] = getDataSize(params.value as number, 2);
  return `${size} ${unit}`;
};

export const dataGridDateFormatter = (params: GridValueFormatterParams) => {
  return format(parseISO(params.value), 'P');
};

export const dataGridDateTimeFormatter = (params: GridValueFormatterParams) => {
  return format(parseISO(params.value), 'Pp');
};

export const dataGridLongDateTimeFormatter = (params: GridValueFormatterParams) => {
  return formatLongDateTimeString(params.value as Date);
};

export const dataGridLongDateTimeNoSecondsFormatter = (params: GridValueFormatterParams) => {
  return formatLongDateTimeString(params.value as Date, false);
};
